import { render, staticRenderFns } from "./CustomerRating.vue?vue&type=template&id=2cf1f413&scoped=true&"
import script from "./CustomerRating.vue?vue&type=script&lang=js&"
export * from "./CustomerRating.vue?vue&type=script&lang=js&"
import style0 from "./CustomerRating.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CustomerRating.vue?vue&type=style&index=1&id=2cf1f413&lang=sass&scoped=true&"
import style2 from "./CustomerRating.vue?vue&type=style&index=2&id=2cf1f413&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf1f413",
  null
  
)

export default component.exports